import styled, { css } from 'styled-components';
import { ReactComponent as SortIcon } from './AZ.svg';
import { SortIconState } from '../../model';
import { Warning as WarningIcon } from 'features/shared/ui/sharedStyled';

export const TableWrap = styled.div`
  position: relative;
  overflow: auto;
  max-height: 353px;
  margin-bottom: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
`;

export const Td = styled.td<{ rowspan?: number; colspan?: number }>`
  border: 1px solid #d9d9d9;
  padding: 16px;
  font-size: 16px;
  line-height: 22px;
`;

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  background: white;
  ${Td} {
    padding: 0px;
  }
`;

export const Tfoot = styled.tfoot`
  position: sticky;
  bottom: 0;
  background: white;
  font-weight: bold;
  color: rgba(9, 21, 38, 0.6);
  max-height: 54px;
`;

export const Tr = styled.tr``;

export const Th = styled.th`
  border: 1px solid #d9d9d9;
  font-weight: bold;
  font-size: 14px !important;
  line-height: 20px !important;
  text-align: center;
  vertical-align: middle;
`;

export const ThContent = styled.div`
  text-align: left;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;

export const Tbody = styled.tbody`
  ${Tr} {
    &:nth-child(even) {
      background: rgba(9, 21, 38, 0.07);
    }
  }
  ${Td} {
    border-top-width: 0px;
    border-bottom-width: 0px;
  }
`;

export const TdWithNumbers = styled(Td)`
  text-align: center;
  span {
    color: rgba(9, 21, 38, 0.35);
  }
`;
export const Municipality = styled(Td)`
  width: 218px;
  max-width: 218px;
`;
export const School = styled(Td)`
  max-width: 250px;
  width: 250px;
`;
export const Regisrations = styled(TdWithNumbers)`
  width: 156px;
  max-width: 156px;
`;
export const Participants = styled(TdWithNumbers)`
  width: 126px;
  max-width: 126px;
  vertical-align: middle;
`;
export const Winners = styled(TdWithNumbers)`
  width: 130px;
  max-width: 130px;
  vertical-align: middle;
`;
export const Sort = styled(SortIcon)<{ state?: SortIconState }>`
  margin-left: 8px;
  path {
    fill: ${({ state }) => {
      return state === SortIconState.ascending || state === SortIconState.descending
        ? '#12B7E7'
        : 'rgba(9, 21, 38, 0.85)';
    }};
    fill-opacity: 1;
  }
  ${({ state }) =>
    state === SortIconState.descending &&
    css`
      transform: scale(1, -1);
    `}
`;

export const Warning = styled(WarningIcon)`
  margin-left: 8px;
`;
